import React, { useState, useEffect, useRef, useMemo } from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";

import { peticionGet } from "Componentes/ComponenteAxios";
import MigaPan from "Componentes/MigaPan";
import TarjetaDosLineas from "Componentes/TarjetaDosLineas";
import VistaMensualDepartamentos from "Componentes/VistaMensualDepartamentos";

const Dashboard = () => {
  const migaPanRef = useRef();
  const [registros, setRegistros] = useState({});

  // ************************************************************************
  // ********** RECUPERA LOS DATOS NECESARIOS
  // ************************************************************************
  useEffect(() => {
    peticionGet("/dashboard").then(({ peticion, error, status }) => {
      if (error) {
        migaPanRef.current?.mostrarSnack({
          mensaje:
            peticion?.mensajeSnack || "No se han podido recuperar los datos",
          tipo: peticion?.tipoSnack || "error",
        });
      } else {
        setRegistros(peticion || {});
      }
    });
  }, []);

  return (
    <Box className="box-contenido-alineado-izquierda">
      <MigaPan ref={migaPanRef} tituloSeccion="DashBoard" />

      <Grid container xs={12} spacing={3} mb={3}>
        {/* <Grid item xs={12} md={4} lg={3}>
          <TarjetaDosLineas
            titulo="Trabajadores"
            valor={registros?.trabajadores?.length}
            ruta="Trabajadores"
            textoBoton="Ver trabajadores"
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <TarjetaDosLineas
            titulo="Turnos creados"
            valor={registros?.turnos?.length}
            ruta="Turnos"
            textoBoton="Ver Turnos"
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <TarjetaDosLineas
            titulo="Tipos de Pausa"
            valor={registros?.pausas?.length}
            ruta="Pausas"
            textoBoton="Ver pausas"
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <TarjetaDosLineas
            titulo="Departamentos"
            valor={registros?.departamentos?.length}
            ruta="DepartamentosSedes"
            textoBoton="Ver y Editar Departamentos"
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <TarjetaDosLineas
            titulo="Puestos de Trabajo"
            valor={registros?.puestos?.length}
            ruta="PuestosTrabajo"
            textoBoton="Ver y Editar Puestos de Trabajo"
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <TarjetaDosLineas
            titulo="Trabajadores asignados"
            valor={registros?.asignaciones_puestos?.length}
          />
        </Grid> */}
        {/* <Grid item xs={12} sm={4} md={4}>
          <TarjetaDosLineas
            titulo="Tarifa Activa"
            valor={registros.tarifaActiva}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TarjetaDosLineas titulo="Buques" valor={registros.totalBuques} />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TarjetaDosLineas
            titulo="Total Clientes"
            valor={registros.totalClientes}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TarjetaDosLineas
            titulo="Total Consignatarios"
            valor={registros.totalConsignatarios}
          />
        </Grid> */}
      </Grid>

      {/* <Grid container xs={12} sm={8} md={8} spacing={3} mb={3}></Grid>

      <Grid container xs={12} sm={8} md={8} spacing={3} mb={3}></Grid> */}

      <VistaMensualDepartamentos />
    </Box>
  );
};

export default Dashboard;
